import { render, staticRenderFns } from "./EditPtspMerchant.vue?vue&type=template&id=abbba9b6"
import script from "./EditPtspMerchant.vue?vue&type=script&lang=js"
export * from "./EditPtspMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports